<template>
	<fragment>
		<li class="pt-8 pb-2 pl-4 pr-4 text-left font-bold">
			{{ title }}
		</li>
	</fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
	props: {
		title: {
			type: String,
			required: true,
		},
	},
	components: {
		Fragment,
	},
};
</script>

<style lang="sass" scoped>
li
	color: $sidebar_text
</style>
